<template>
  <div class="media-preview-dialog">
    <el-dialog
      v-if="preview.dialog"
      id="imagePreviewDialog"
      class="media-preview-dialog z-998 bg-black/50"
      :z-index="998"
      :model-value="preview.dialog"
      :close-on-click-modal="false"
      :modal="false"
      :show-close="false"
      @close="$emit('close')">
      <button class="absolute top-[10px] right-[14px] border-none bg-transparent p-0 cursor-pointer" @click="$emit('close')">
        <font-awesome-icon icon="fa-solid fa-xmark"/>
      </button>
      <img class="inline-block" :src="preview.image.url" />
    </el-dialog>
  </div>
</template>

<script src="./image-preview-dialog.js"></script>
